"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledInfoBoxWrapper = exports.StyledInfoBoxSuffix = exports.StyledInfoBoxPrefix = exports.StyledInfoBoxContent = exports.StyledInfoBoxContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledInfoBoxWrapper = exports.StyledInfoBoxWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1d74pas-0"
})([""]);
var StyledInfoBoxPrefix = exports.StyledInfoBoxPrefix = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1d74pas-1"
})([""]);
var StyledInfoBoxSuffix = exports.StyledInfoBoxSuffix = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1d74pas-2"
})([""]);
var StyledInfoBoxContainer = exports.StyledInfoBoxContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1d74pas-3"
})([""]);
var StyledInfoBoxContent = exports.StyledInfoBoxContent = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1d74pas-4"
})([""]);
var StyledInfoBox = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1d74pas-5"
})(["width:100%;display:inline-block;vertical-align:top;background-color:", ";border-radius:", ";border:", ";", "{position:relative;display:flex;width:100%;}", ",", "{display:inline-block;z-index:9;padding:", ";white-space:nowrap;vertical-align:middle;line-height:0;}", "{padding:", ";}", "{vertical-align:middle;margin-bottom:0;height:100%;width:100%;overflow:hidden;color:", ";", "{padding:", ";height:100%;font-size:", ";ul{font-size:", ";margin:", ";padding-inline-start:", ";li::marker{color:", ";}}}}", ":not (:first-child){", "{border-left:", ";}}", ":not (:last-child){", "{border-right:", ";}}", "{&.bordered{border-right:1px solid ", ";padding-right:10px;}", "{font-size:", ";}}", "{", "{font-size:", ";cursor:pointer;}}", "{", "{border:0 !important;line-height:", ";}}background-color:", ";border-color:", ";", ",", "{", "{color:", ";}}"], function (props) {
  return props.theme.infoBox.backgroundColor;
}, function (props) {
  return props.theme.infoBox.border.radius;
}, function (props) {
  return props.bordered ? props.theme.infoBox.border.width + ' ' + props.theme.infoBox.border.style + ' ' + props.theme.infoBox.border.color : 'none';
}, StyledInfoBoxWrapper, StyledInfoBoxPrefix, StyledInfoBoxSuffix, function (props) {
  return props.theme.infoBox.icon.padding;
}, StyledInfoBoxSuffix, function (props) {
  return props.theme.infoBox.icon.suffixPadding;
}, StyledInfoBoxContainer, function (props) {
  return props.theme.infoBox.textColor;
}, StyledInfoBoxContent, function (props) {
  return props.theme.infoBox.contentPadding;
}, function (props) {
  return props.theme.infoBox.fontSize;
}, function (props) {
  return props.theme.infoBox.ul.fontSize;
}, function (props) {
  return props.theme.infoBox.ul.margin;
}, function (props) {
  return props.theme.infoBox.ul.paddingInlineStart;
}, function (props) {
  return props.theme.infoBox.type[props.type].iconColor;
}, StyledInfoBoxContainer, StyledInfoBoxContent, function (props) {
  return props.theme.infoBox.border.width + ' ' + props.theme.infoBox.border.style + ' ' + props.theme.infoBox.border.color;
}, StyledInfoBoxContainer, StyledInfoBoxContent, function (props) {
  return props.theme.infoBox.border.width + ' ' + props.theme.infoBox.border.style + ' ' + props.theme.infoBox.border.color;
}, StyledInfoBoxPrefix, function (props) {
  return props.theme.infoBox.border.color;
}, _StyledIcon.default, function (props) {
  return props.theme.infoBox.icon.size;
}, StyledInfoBoxSuffix, _StyledIcon.default, function (props) {
  return props.theme.infoBox.icon.size;
}, StyledInfoBoxContainer, StyledInfoBoxContent, function (props) {
  return props.theme.infoBox.lineHeight;
}, function (props) {
  return props.theme.infoBox.type[props.type].backgroundColor;
}, function (props) {
  return props.theme.infoBox.type[props.type].borderColor;
}, StyledInfoBoxPrefix, StyledInfoBoxSuffix, _StyledIcon.default, function (props) {
  return props.theme.infoBox.type[props.type].iconColor;
});
var _default = exports.default = StyledInfoBox;